module.exports = __webpack_public_path__ + "static/media/Intergalactic Girl.2408a0f1.jpg";